<script>
import {updateSubcriberProfile} from "@/api/subscribers";
import {dateFormat} from "@/utils";
import countries from "@/data/countries.json";
import usStates from "@/data/usStates.json";
import {required, alpha, email, alphaNum, minLength, numeric, url, maxLength} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

export default {
  name: "profile-form",
  props: ["item"],
  mixins: [validationMixin],
  validations: {
    profile: {
      first_name: {
        required,
        alpha,
        minLength: minLength(3)

      },
      last_name: {
        required,
        alpha,
        minLength: minLength(3)

      },
      email: {
        required,
        email
      },
      phone_number: {
        required,
        numeric,
        minLength: minLength(11)
      },
      company_name: {
        alphaNum,

      },
      company_website_url: {
        url,
        required
      },
      street: {
        required
      },
      city: {
        required
      },
      zip: {
        required,
        numeric,
        minLength: minLength(5),
      },
      birth_date: {
        required
      },
      marriage_date: {
        required
      },
      first_visit: {
        required
      },
    }
  },
  data: () => ({
    valid: true,
    edit: false,
    update: false,

    genderOptions: [
      {value: "male", text: "Male"},
      {value: "female", text: "Female"}
    ],
    profile: {
      id: "",
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      company_name: "",
      company_website_url: "",
      company_logo: "",
      street: "",
      city: "",
      state: "",
      country: "",
      zip: "",
      name: "",
      birth_date: null,
      marriage_date: null,
      first_visit: null,
      location: null
    },
    dateSubscribed: "",
    countries: [],
    menuDob: false,
    menuMarriage: false,
    menuFirstVisit: false,
    date: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    date3: new Date().toISOString().substr(0, 10)
  }),
  mounted() {
    this.countries = countries;
    setTimeout(() => this.getItem(), 1000);
  },
  computed: {
    firstNameErrors() {
      const errors = []
      if (!this.$v.profile.first_name.$dirty) return errors
      !this.$v.profile.first_name.minLength && errors.push('Name must be at most 3 characters long')
      !this.$v.profile.first_name.required && errors.push('Name is required.')
      !this.$v.profile.first_name.alpha && errors.push('Field can only take Alphabets')
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.profile.last_name.$dirty) return errors
      !this.$v.profile.last_name.minLength && errors.push('Name must be at most 3 characters long')
      !this.$v.profile.last_name.required && errors.push('Name is required.')
      !this.$v.profile.last_name.alpha && errors.push('Field can only take Alphabets')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.profile.email.$dirty) return errors
      !this.$v.profile.email.email && errors.push('Must be valid e-mail')
      !this.$v.profile.email.required && errors.push('E-mail is required')
      return errors
    },
    phoneErrors() {
      const errors = []
      if (!this.$v.profile.phone_number.$dirty) return errors
      !this.$v.profile.phone_number.minLength && errors.push('Invalid phone number')
      !this.$v.profile.phone_number.required && errors.push('Phone is required.')
      !this.$v.profile.phone_number.numeric && errors.push('Invalid phone number')
      return errors
    },
    companyNameErrors() {
      const errors = []
      if (!this.$v.profile.company_name.$dirty) return errors
      !this.$v.profile.company_name.alphaNum && errors.push('Field cannot take symbols')
      return errors
    },
    companyURLErrors() {
      const errors = []
      if (!this.$v.profile.company_website_url.$dirty) return errors
      !this.$v.profile.company_website_url.url && errors.push('Must be valid URL')
      !this.$v.profile.company_website_url.required && errors.push('URL is required')
      return errors
    },
    streetErrors() {
      const errors = []
      if (!this.$v.profile.street.$dirty) return errors
      !this.$v.profile.street.required && errors.push('Street Address is required')
      return errors
    },
    cityErrors() {
      const errors = []
      if (!this.$v.profile.city.$dirty) return errors
      !this.$v.profile.city.required && errors.push('City is required')
      return errors
    },
    zipErrors() {
      const errors = []
      if (!this.$v.profile.zip.$dirty) return errors
      !this.$v.profile.zip.minLength && errors.push('Invalid Zip code')
      !this.$v.profile.zip.required && errors.push('Zip code is required.')
      !this.$v.profile.zip.numeric && errors.push('Invalid Zip code')
      return errors
    },
    birthDayErrors() {
      const errors = []
      if (!this.$v.profile.birth_date.$dirty) return errors
      !this.$v.profile.birth_date.required && errors.push('Date of birth is required')
      return errors
    },
    mDayErrors() {
      const errors = []
      if (!this.$v.profile.marriage_date.$dirty) return errors
      !this.$v.profile.marriage_date.required && errors.push('Date is required')
      return errors
    },
    firstErrors() {
      const errors = []
      if (!this.$v.profile.first_visit.$dirty) return errors
      !this.$v.profile.first_visit.required && errors.push('Date is required')
      return errors
    },

    countriesOptions() {
      return [
        {value: "United States", text: "United States"},
        ...this.countries.map(list => {
          return {
            value: list.name,
            text: list.name
          };
        })
      ];
    },
    statesOptions() {
      return [
        {value: null, text: "Please select"},
        ...usStates.map(list => {
          return {
            value: list.name,
            text: list.name
          };
        })
      ];
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getItem() {
      this.profile.id = this.item && this.item.profile && this.item.profile.id
          ? this.item.profile.id
          : null;
      this.profile.first_name = this.capitalizeFirstLetter(this.item.profile.first_name)
      this.profile.last_name = this.capitalizeFirstLetter(this.item.profile.last_name);
      this.profile.email =
          this.item && this.item.profile ? this.item.profile.email : null;
      this.dateSubscribed =
          this.item && this.item.created ? dateFormat(this.item.created) : null;
      this.profile.phone_number =
          this.item && this.item.profile ? this.item.profile.phone_number : null;
      this.profile.company_name =
          this.item && this.item.profile ? this.item.profile.company_name : null;
      this.profile.company_website_url =
          this.item && this.item.profile
              ? this.item.profile.company_website_url
              : null;
      this.profile.street =
          this.item && this.item.profile ? this.item.profile.street : null;
      this.profile.city =
          this.item && this.item.profile ? this.item.profile.city : null;
      this.profile.state =
          this.item && this.item.profile ? this.item.profile.state : null;
      this.profile.country =
          this.item && this.item.profile ? this.item.profile.country : null;
      this.profile.zip =
          this.item && this.item.profile ? this.item.profile.zip : null;
      this.date =
          this.item && this.item.profile && this.item.profile.birth_date
              ? this.item.profile.birth_date
              : null;
      this.date2 =
          this.item && this.item.profile && this.item.profile.marriage_date
              ? this.item.profile.marriage_date
              : null;
      this.date3 =
          this.item && this.item.profile && this.item.profile.first_visit
              ? this.item.profile.first_visit
              : null;
      this.profile.location = this.item && this.item.location ? this.item.location : null;


    },
    validate() {
      this.$refs.form.validate();
    },
    editForm() {
      this.edit = true;
      this.valid = false;
      this.update = true;
    },
    async updateForm() {
      let error = 0;
      let error_msg = "";
      this.edit = false;
      this.valid = true;
      this.update = false;
      this.profile.name = `${this.profile.first_name} ${this.profile.last_name}`;
      this.profile.birth_date = this.date;
      this.profile.marriage_date = this.date2;
      this.profile.first_visit = this.date3;

      console.log(this.profile);

      // if (this.profile.email == "" || this.profile.email == null) {
      //   error += 1;
      //   error_msg += " Email is required. ";
      // }
      // if (this.profile.company_website_url == "" || this.profile.company_website_url == null) {
      //   error += 1;
      //   error_msg += " Company Website is required. ";
      // }
      // if (this.profile.phone_number == "" || this.profile.phone_number == null) {
      //   error += 1;
      //   error_msg += " Phone Number is required. ";
      // }

      if (error > 0) {
        this.$bvToast.toast(error_msg, {
          title: "Basic Information",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger"
        });
      } else {
        const payload = JSON.parse(JSON.stringify(this.profile));
        const response = await updateSubcriberProfile(this.item.id, payload);
        if (response) {
          this.$bvToast.toast(`Profile updated`, {
            title: "Basic Information",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "success"
          });
          this.$store.dispatch("getSubcriberProfile");
        } else {
          this.$bvToast.toast(`Error in updating`, {
            title: "Basic Information",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "danger"
          });
        }
      }
    }
  }
};
</script>

<template>
  <v-row class="p-1">
    <v-col cols="12">
      <v-card class="rounded-lg mb-5 mt-1" outlined>
        <v-card-title>
          <span class="title font-weight-bold">
            BASIC INFORMATION
          </span>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" v-show="!edit" depressed tile @click="editForm()">
            <v-icon left> mdi-pencil</v-icon>
            Edit
          </v-btn>
          <v-btn
              class="mr-4"
              v-show="update"
              color="primary"
              tile
              @click="updateForm()"
          >
            Save Changes
          </v-btn>
        </v-card-title>
        <v-form
            inline
            ref="form"
            lazy-validation
            class="pt-0 pl-5 pr-5"
            :disabled="valid"
        >
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="profile.first_name"
                  label="First name"
                  required
                  :error-messages="firstNameErrors"
                  @input="$v.profile.first_name.$touch()"
                  @blur="$v.profile.first_name.$touch()"
                  :counter="255"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="profile.last_name"
                  label="Last name"
                  required
                  :error-messages="lastNameErrors"
                  @input="$v.profile.last_name.$touch()"
                  @blur="$v.profile.last_name.$touch()"
                  :counter="255"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="profile.email"
                  label="Email"
                  required
                  :error-messages="emailErrors"
                  @input="$v.profile.email.$touch()"
                  @blur="$v.profile.email.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="profile.phone_number"
                  label="Phone"
                  type="tel"
                  :error-messages="phoneErrors"
                  @input="$v.profile.phone_number.$touch()"
                  @blur="$v.profile.phone_number.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="profile.company_name"
                  label="Company"
                  :error-messages="companyNameErrors"
                  @input="$v.profile.company_name.$touch()"
                  @blur="$v.profile.company_name.$touch()"
                  :counter="255"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="profile.company_website_url"
                  label="Company Website"
                  :error-messages="companyURLErrors"
                  @input="$v.profile.company_website_url.$touch()"
                  @blur="$v.profile.company_website_url.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="profile.street"
                  label="Street"
                  :error-messages="streetErrors"
                  @input="$v.profile.street.$touch()"
                  @blur="$v.profile.street.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="profile.city" label="City"
                            :error-messages="cityErrors"
                            @input="$v.profile.city.$touch()"
                            @blur="$v.profile.city.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n5">
            <v-col cols="12" sm="4">
              <v-select
                  v-model="profile.state"
                  label="State"
                  :items="statesOptions"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                  v-model="profile.country"
                  :items="countriesOptions"
                  label="Country"
                  value="United States"
                  disabled
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                  v-model="profile.zip" label="Zip"
                  :error-messages="zipErrors"
                  @input="$v.profile.zip.$touch()"
                  @blur="$v.profile.zip.$touch()"

              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-n5">
            <v-col cols="12" sm="4">
              <v-menu
                  ref="menuDob"
                  v-model="menuDob"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Date of Birth"
                      required
                      @input="$v.profile.birth_date.$touch()"
                      @blur="$v.profile.birth_date.$touch()"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-btn text color="primary" @click="menuDob = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menuDob.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4">
              <v-menu
                  ref="menuMarriage"
                  v-model="menuMarriage"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date2"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Date of Marriage"
                      required
                      @input="$v.profile.marriage_date.$touch()"
                      @blur="$v.profile.marriage_date.$touch()"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2" no-title scrollable>
                  <v-btn text color="primary" @click="menuMarriage = false">
                    Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.menuMarriage.save(date2)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4">
              <v-menu
                  ref="menuFirstVisit"
                  v-model="menuFirstVisit"
                  :close-on-content-click="false"
                  :return-value.sync="date3"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date3"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Date of First Visit"
                      required
                      @input="$v.profile.first_visit.$touch()"
                      @blur="$v.profile.first_visit.$touch()"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date3" no-title scrollable>
                  <v-btn text color="primary" @click="menuFirstVisit = false">
                    Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.menuFirstVisit.save(date3)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.theme--light.v-tabs-items {
  background-color: #ffffff;
}
</style>
